export const DROP_IDS = {
  blockOrder: 'droppable-block-order',
  blockSelectorContent: 'droppable-block-selector-content',
  blockSelectorSubTasks: 'droppable-block-selector-subTasks',
  blockEnrollmentFormFields: 'droppable-block-enrollment-form-fields'
};
